import React from 'react';
import { ArrowRight } from 'lucide-react';

const caseStudies = [
  {
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&q=80',
    title: 'Retail Analytics Revolution',
    industry: 'Retail',
    challenge: 'A leading retailer needed to optimize inventory and predict customer behavior.',
    solution: 'Implemented AI-driven analytics platform with real-time insights.',
    result: 'Result: Achieved a 20% increase in sales of high-demand items and a 15% reduction in inventory holding costs within 6 months, significantly improving capital efficiency and market responsiveness.',
  },
  {
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80',
    title: 'Automated Operations Excellence',
    industry: 'Financial Services',
    challenge: 'Manual back-office processes causing delays and errors.',
    solution: 'Deployed intelligent automation suite for core operations.',
    result: 'Result: Delivered a 35% reduction in operational costs and a 60% acceleration in processing time for core back-office functions, leading to substantial annual savings and enhanced service delivery.',
  },
  {
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80',
    title: 'Healthcare Scheduling Optimization',
    industry: 'Healthcare',
    challenge: 'Inefficient patient scheduling leading to long wait times.',
    solution: 'Developed predictive modeling system for appointment scheduling.',
    result: 'Result: Successfully decreased patient wait times by an average of 40% and significantly improved patient satisfaction scores by 25%, optimizing resource allocation and enhancing the patient experience.',
  },
];

const CaseStudies = () => {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 fade-in-up">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Success Stories
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            See how Agility.AI Technologies has helped businesses transform their operations using cutting-edge AI solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {caseStudies.map((study, index) => (
            <div
              key={index}
              className="bg-gray-900/50 backdrop-blur-sm rounded-lg overflow-hidden shadow-lg 
                hover:shadow-xl transition-all duration-300 flex flex-col
                border border-gray-800/50 hover:bg-gray-900/70 card-hover fade-in-up"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={study.image}
                  alt={study.title}
                  className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="text-sm text-teal-400 font-semibold mb-2">{study.industry}</div>
                <h3 className="text-xl font-bold text-white mb-3">{study.title}</h3>
                <div className="space-y-2 mb-4 flex-1">
                  <p className="text-gray-400"><span className="font-semibold text-gray-300">Challenge:</span> {study.challenge}</p>
                  <p className="text-gray-400"><span className="font-semibold text-gray-300">Solution:</span> {study.solution}</p>
                  <p className="text-gray-400"><span className="font-semibold text-gray-300">{study.result}</span></p>
                </div>
                <button className="text-teal-400 font-medium flex items-center space-x-2 group hover:text-teal-300 text-link">
                  <span>Read Full Case Study</span>
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;